/** One description per design, shared across sizes; no network request needed. */
class FaithDesignDescriptions extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('product-component');
    this.scope?.addEventListener('change', this.onChange);
    this.sync();
  }

  disconnectedCallback() {
    this.scope?.removeEventListener('change', this.onChange);
  }

  onChange = (event) => {
    if (event.target.closest('variant-picker')) this.sync();
  };

  sync() {
    const group = this.scope?.querySelector('variant-picker [data-option-position="1"]');
    const selected = group?.querySelector('input:checked, select');
    const value = selected?.value ?? group?.dataset.selectedValue ?? this.dataset.selectedDesign ?? '';
    const key = value.includes('(Know Him, Love Him, Follow Him)') ? 'know' : 'parish';
    for (const panel of this.querySelectorAll('[data-faith-description]')) {
      panel.hidden = panel.dataset.faithDescription !== key;
    }
  }
}
if (!customElements.get('faith-design-descriptions')) {
  customElements.define('faith-design-descriptions', FaithDesignDescriptions);
}
